
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M27 32.5c0 1.933-1.79 3.5-4 3.5s-4-1.567-4-3.5 1.79-3.5 4-3.5 4 1.567 4 3.5M43 31.5c0-2.56-.491-5.096-1.446-7.462a19.5 19.5 0 0 0-4.119-6.327l-8.978 9.214c.586.601 1.05 1.314 1.367 2.1.316.784.48 1.625.48 2.475z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Line 36",attrs:{"stroke":"#234652","d":"m41 28-14 2"}}),_c('circle',{staticClass:"i-Ellipse 34",attrs:{"r":"3.5","stroke":"#234652","transform":"matrix(-1 0 0 1 24 31)"}}),_c('path',{staticClass:"i-Ellipse 35",attrs:{"stroke":"#234652","d":"M2 31C2 18.85 11.85 9 24 9s22 9.85 22 22"}}),_c('path',{staticClass:"i-Ellipse 36",attrs:{"stroke":"#234652","stroke-dasharray":"1 6","d":"M6 31c0-9.941 8.059-18 18-18s18 8.059 18 18"}})])
          )
        }
      }
    